import { create } from 'zustand'

/**
 * "Apply changes without asking" (2026-10-15, one-assistant Phase 2c).
 *
 * Off by default: a change that asks first (toolEffect 'confirm') waits for the
 * trader's Apply. On, the card is skipped for those changes, except the ones
 * that remove something (`alwaysAsk` on the tool's manifest, read with
 * `toolAlwaysAsks`), which always ask. A trust preference, not a safety rule:
 * whether a turn may change anything at all is the turn check's call (Phase 2b)
 * and is never a setting.
 *
 * One bounded localStorage key (the quota rule).
 */
export const APPLY_WITHOUT_ASKING_KEY = 'edge:companion:apply-without-asking'

function readPersisted(): boolean {
  try {
    return localStorage.getItem(APPLY_WITHOUT_ASKING_KEY) === '1'
  } catch {
    return false
  }
}

interface ApplyWithoutAskingState {
  enabled: boolean
  setEnabled: (enabled: boolean) => void
}

export const useApplyWithoutAskingStore = create<ApplyWithoutAskingState>((set) => ({
  enabled: readPersisted(),
  setEnabled: (enabled) => {
    try {
      if (enabled) localStorage.setItem(APPLY_WITHOUT_ASKING_KEY, '1')
      else localStorage.removeItem(APPLY_WITHOUT_ASKING_KEY)
    } catch {
      /* ignore quota / unavailable storage */
    }
    set({ enabled })
  },
}))
